export default __webpack_public_path__ + "static/media/server_error.6a54bb6c.svg";